exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-modules-tables-components-SimpleFilter-___styles__input___3wVIv {\n  max-width: 15rem;\n  min-width: 3rem; }\n", ""]);

// exports
exports.locals = {
	"input": "src-modules-tables-components-SimpleFilter-___styles__input___3wVIv"
};